import { Outlet, Route } from 'react-router'
import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { IdleTimerEnrollment } from '@egw/features-auth'
import { WEALTH_ROUTES } from '@egw/constants'
import { useSubmitEnrollmentAbandonApplicationData } from '@egw/api'
import { ROUTES } from '../../constants/routes/routes-multi'
import { ALL_ENROLLMENT_ROUTES } from '../../constants'
import { AccountTransferPage } from './account-transfer'
import { AccountTransferSuccessPage } from './account-transfer-success'
import { BankTransferPage } from './bank-transfer'
import { BankTransferSuccessPage } from './bank-transfer-success'
import { ConfirmInformationPage } from './confirm-information'
import { CreatePasskeyPage } from './create-passkey'
import { DisclosuresPage } from './disclosures'
import { DocumentVerificationPage } from './document-verification'
import { DocumentVerificationCompletePage } from './document-verification-complete'
import { EmploymentPage } from './employment'
import { FundAccountPage } from './fund-account'
import { GetStartedPage } from './get-started'
import { HomePage } from './home'
import { HomeAddressPage } from './home-address'
import { InvestmentGoalsPage } from './investment-goals'
import { ManualReviewPage } from './manual-review'
import { SuitabilityPage } from './suitability'
import { VerifyEmailPage } from './verify-email'
import { VerifyIdentityPage } from './verify-identity'
import { VerifyPhonePage } from './verify-phone'
import { WelcomePage } from './welcome'
import { WireTransferPage } from './wire-transfer'
import { FinancesPage } from './finances'
import { SignInPage } from './return/sign-in'
import { ReturnVerifyEmailPage } from './return/verify-email'
import { ReturnVerifyPhonePage } from './return/verify-phone'
import { ReturnEnterPhonePage } from './return/enter-phone'
//INTEGRATION:EnrolmentImports

/**
 * Enrollment Multi level components that are not tied to a specific route, such as IDLE modal
 */
const AppComponents: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { mutate } = useSubmitEnrollmentAbandonApplicationData()

  const signOutRoute = `${WEALTH_ROUTES.ENROLLMENT.path}/${ALL_ENROLLMENT_ROUTES.GENERIC.ROUTES.TIMED_OUT.path}`

  return (
    <IdleTimerEnrollment
      title={t('multi.idle.session_expired')}
      message={t('multi.idle.session_timeout_description')}
      signOutRoute={signOutRoute}
      onSignOut={() => {
        mutate({
          abandonApplication: true,
        })
      }}
    />
  )
}

export const routerMulti = (): JSX.Element | null => {
  return (
    <Route
      key="location-manager"
      path=""
      element={
        <>
          {/* Add custom LocationManager component here to add any redirect logic */}
          <AppComponents />
          <Outlet />
        </>
      }
    >
      {/* INTEGRATION:EnrollmentRoute */}
      <Route path={ROUTES.RETURN_ENTER_PHONE.path} element={<ReturnEnterPhonePage />} />
      <Route path={ROUTES.RETURN_VERIFY_PHONE.path} element={<ReturnVerifyPhonePage />} />
      <Route path={ROUTES.RETURN_VERIFY_EMAIL.path} element={<ReturnVerifyEmailPage />} />
      <Route path={ROUTES.RETURN_SIGN_IN.path} element={<SignInPage />} />
      <Route path={ROUTES.FINANCES.path} element={<FinancesPage />} />
      <Route path={ROUTES.BANK_TRANSFER_SUCCESS.path} element={<BankTransferSuccessPage />} />
      <Route path={ROUTES.CONFIRM_INFORMATION.path} element={<ConfirmInformationPage />} />
      <Route path={ROUTES.ACCOUNT_TRANSFER.path} element={<AccountTransferPage />} />
      <Route path={ROUTES.BANK_TRANSFER.path} element={<BankTransferPage />} />
      <Route path={ROUTES.DISCLOSURES.path} element={<DisclosuresPage />} />
      <Route path={ROUTES.WIRE_TRANSFER.path} element={<WireTransferPage />} />
      <Route path={ROUTES.FUNDING.path} element={<FundAccountPage />} />
      <Route path={ROUTES.ACCOUNT_TRANSFER_SUCCESS.path} element={<AccountTransferSuccessPage />} />
      <Route path={ROUTES.SUITABILITY.path} element={<SuitabilityPage />} />
      <Route path={ROUTES.INVESTMENT_GOALS.path} element={<InvestmentGoalsPage />} />
      <Route path={ROUTES.EMPLOYMENT.path} element={<EmploymentPage />} />
      <Route path={ROUTES.WELCOME.path} element={<WelcomePage />} />
      <Route path={ROUTES.MANUAL_REVIEW.path} element={<ManualReviewPage />} />
      <Route path={ROUTES.DOCUMENT_VERIFICATION.path} element={<DocumentVerificationPage />} />
      <Route path={ROUTES.DOCUMENT_VERIFICATION_COMPLETE.path} element={<DocumentVerificationCompletePage />} />
      <Route path={ROUTES.VERIFY_EMAIL.path} element={<VerifyEmailPage />} />
      <Route path={ROUTES.MULTI_VERIFY_PHONE.path} element={<VerifyPhonePage />} />
      <Route path={ROUTES.MULTI_GET_STARTED.path} element={<GetStartedPage />} />
      <Route path={ROUTES.VERIFY_IDENTITY.path} element={<VerifyIdentityPage />} />
      <Route path={ROUTES.HOME_ADDRESS.path} element={<HomeAddressPage />} />
      <Route path={ROUTES.CREATE_PASSKEY.path} element={<CreatePasskeyPage />} />
      <Route path={ROUTES.MULTI_HOME.path} element={<HomePage />} />
    </Route>
  )
}
